<template>
    <div :class="`as-goals-scored`">
        <div class="as-goals-scored__head">
            <IconOffsideMis/>
            <span> Việt vị & Misc  </span>
        </div>
        <div class="as-history">
            <div class="as-history-item">
                <div class="as-history-item__head">
                    <div class="as-head-tab as-uppercase" :class="{
                        'as-active': activeTab === 'team'
                    }" @click="setActiveTab('team')">
                        Đội việt vị
                    </div>
                    <div class="as-head-tab as-uppercase" :class="{
                        'as-active': activeTab === 'all'
                    }" @click="setActiveTab('all')">
                        Việt vị trận đấu
                    </div>
                </div>
                <div class="as-history-item__body">
                    <div class="as-competition">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Đội việt vị</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in offsides" :key="index">
                                    <td>{{ item.title }}</td>
                                    <td :class="`as-center ${item.home._class}`">{{ item.home.value }}%</td>
                                    <td :class="`as-center ${item.away._class}`">{{ item.away.value }}%</td>
                                    <td :class="`as-center ${item.avg._class}`">{{ item.avg.value }}%</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="as-competition">
                        <table class="as-competition__table">
                            <thead>
                                <tr>
                                    <th>Thống kê đa dạng</th>
                                    <th class="as-center a">{{ footyStats?.home_name }}</th>
                                    <th class="as-center a">{{ footyStats?.away_name }}</th>
                                    <th class="as-center a">Trung bình</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in mics" :key="index">
                                    <td>{{ item.title }}</td>
                                    <td :class="`as-center ${item.home._class}`">{{ item.home.value }}{{ item.is_percent ? '%' : '' }}</td>
                                    <td :class="`as-center ${item.away._class}`">{{ item.away.value }}{{ item.is_percent ? '%' : '' }}</td>
                                    <td :class="`as-center ${item.avg._class}`">{{ item.avg.value }}{{ item.is_percent ? '%' : '' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import IconOffsideMis from '~src/components/icons/foot_stats/IconOffsideMis.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';
    import { ref, computed } from 'vue';
    import { getClassForItem } from '~src/helpers/footystats';

    interface Props{
        match: IMatch;
        mode?: string;
        footyStats: IFootyStats | null;
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    interface IData{
        title: string;
        home: {
            value: number;
            _class: string;
        };
        away: {
            value: number;
            _class: string;
        };
        avg: {
            value: number;
            _class: string;
        };
        is_percent?: boolean;
    }

    const props = withDefaults(defineProps<Props>(),{
        mode: 'as-win'
    })

    const activeTab = ref('team')
    const setActiveTab = (tab: string) => {
        activeTab.value = tab;
    };

    const offsides = computed(() => {
        const _data: IData[] = [
            {
                title: "TB Việt vị mỗi đội",
                home: {
                    value: getValueWithMode('home', 'offsidesAVG_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'offsidesAVG_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'offsidesAVG_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'offsidesAVG_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'offsidesAVG_overall'), getValueWithMode('away', 'offsidesAVG_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'offsidesAVG_overall'), getValueWithMode('away', 'offsidesAVG_overall')))
                },
                is_percent: false
            },
            {
                title: "Trên 0.5",
                home: {
                    value: getValueWithMode('home', 'over05OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over05OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over05OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over05OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over05OffsidesPercentage_overall'), getValueWithMode('away', 'over05OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over05OffsidesPercentage_overall'), getValueWithMode('away', 'over05OffsidesPercentage_overall')))
                },
                is_percent: true
            },
            {
                title: "Trên 1.5",
                home: {
                    value: getValueWithMode('home', 'over15OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over15OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over15OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over15OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over15OffsidesPercentage_overall'), getValueWithMode('away', 'over15OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over15OffsidesPercentage_overall'), getValueWithMode('away', 'over15OffsidesPercentage_overall')))
                },
                is_percent: true
            },
            {
                title: "Trên 2.5",
                home: {
                    value: getValueWithMode('home', 'over25OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over25OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over25OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over25OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over25OffsidesPercentage_overall'), getValueWithMode('away', 'over25OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over25OffsidesPercentage_overall'), getValueWithMode('away', 'over25OffsidesPercentage_overall')))
                },
                is_percent: true
            },
            {
                title: "Trên 3.5",
                home: {
                    value: getValueWithMode('home', 'over35OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'over35OffsidesPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'over35OffsidesPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'over35OffsidesPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'over35OffsidesPercentage_overall'), getValueWithMode('away', 'over35OffsidesPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'over35OffsidesPercentage_overall'), getValueWithMode('away', 'over35OffsidesPercentage_overall')))
                },
                is_percent: true
            }
        ]

        return _data;
    });

    const mics = computed(() => {
        const _data: IData[] = [
            {
                title: "Phạm lỗi/trận đấu",
                home: {
                    value: getValueWithMode('home', 'foulsAVG_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'foulsAVG_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'foulsAVG_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'foulsAVG_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'foulsAVG_overall'), getValueWithMode('away', 'foulsAVG_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'foulsAVG_overall'), getValueWithMode('away', 'foulsAVG_overall')))
                },
            },
            {
                title: "Đối thủ phạm lỗi/trận đấu",
                home: {
                    value: getValueWithMode('home', 'fouls_against_avg_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'fouls_against_avg_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'fouls_against_avg_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'fouls_against_avg_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'fouls_against_avg_overall'), getValueWithMode('away', 'fouls_against_avg_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'fouls_against_avg_overall'), getValueWithMode('away', 'fouls_against_avg_overall')))
                },
            },
            {
                title: "Kiểm soát trung bình",
                home: {
                    value: getValueWithMode('home', 'possessionAVG_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'possessionAVG_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'possessionAVG_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'possessionAVG_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'possessionAVG_overall'), getValueWithMode('away', 'possessionAVG_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'possessionAVG_overall'), getValueWithMode('away', 'possessionAVG_overall')))
                },
            },
            {
                title: "Hòa",
                home: {
                    value: getValueWithMode('home', 'drawPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('home', 'drawPercentage_overall'))
                },
                away: {
                    value: getValueWithMode('away', 'drawPercentage_overall'),
                    _class: getClassForItem(getValueWithMode('away', 'drawPercentage_overall'))
                },
                avg: {
                    value: calculatorAVG(getValueWithMode('home', 'drawPercentage_overall'), getValueWithMode('away', 'drawPercentage_overall')),
                    _class: getClassForItem(calculatorAVG(getValueWithMode('home', 'drawPercentage_overall'), getValueWithMode('away', 'drawPercentage_overall')))
                },
            }
        ]

        return _data;
    });

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts', half = 1) => {
        const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;
        if (!__data || !__data.stats || !__data.stats.stats.hasOwnProperty(mode)) {
            return 0;
        }

        return __data.stats[mode] as number;
    }

    const calculatorAVG = (home: number, away: number) => {
        const _avg = (home + away) / 2

        return Math.round(_avg)
    }

</script>
<script lang="ts">
export default {};
</script>
